import React, { useState } from "react";
import styles from '../styles/paginationTo.module.scss'

const paginationTo = ({ current = 1, total, pageSize, onChange  }) => {
  //  总页数
  const totalPages = Math.ceil(total / pageSize);
  // 鼠标悬浮状态管理
  const [hovered, setHovered] = useState<'prev' | 'next' | null>(null)

  // 处理渲染数字页码逻辑
  const getPageList = (): (number | 'prev' | 'next')[]  => {
    const pages: (number | 'prev' | 'next')[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (current <= 4) {
      pages.push(1, 2, 3, 4, 'next', totalPages);
    } else if (current >= totalPages - 3) {
      pages.push(1, 'prev', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, 'prev', current - 1, current, current + 1, 'next', totalPages);
    }
    return pages;
  };
  const pageList = getPageList();

  // 点击跳转页码
  const handleClick = (page) => {
    if (page === 'prev') onChange(Math.max(1, current - 4));
    else if (page === 'next') onChange(Math.min(totalPages, current + 4));
    else if (page !== current) onChange(page);
  };

  return (
    <div className={styles.paginationTo}>
      <button onClick={() => onChange(current - 1)} disabled={current === 1} className={styles.pageTo}>{'<'}</button>

      {pageList.map((v,index)=>{
        // 数字页码中间...状态渲染
        if( v === 'prev' || v === 'next'){
          // 判定是否悬浮
          const isHovered = hovered === v
          const label = isHovered ? (v === 'prev' ? '«' : '»') : '...'

          return (
            <button 
              key={`${v}-${index}`}
              onMouseEnter={() => setHovered(v)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => handleClick(v)}
              className={styles.ellipsisButton}
            >
              {label}
            </button>
          )
        }

        return (
          <button
            key={`${v}-${index}`}
            onClick={() => handleClick(v)}
            className={`${styles.pageButton} ${current === v ? styles.active : ''}`}
          >
            {v}
          </button>
        )
      })}

      <button onClick={() => onChange(current + 1)} disabled={current === totalPages} className={styles.pageTo}>{'>'}</button>
    </div>
  )
}

export default paginationTo